
import "./styles.css";

import Banner from "../../components/Banner";
import FreeExpiredGuard from "../../components/FreeExpiredGuard";
import FreePlanBanner from "../../components/FreePlanBanner";
import FreePlanInfoCard from "../../components/FreePlanInfoCard";
import Menu from "../../components/Menu";
import NavbarDashboard from "../../components/NavbarDashboard";

function Main() {
  return (
    <FreeExpiredGuard>
      <NavbarDashboard />

      <section className="home">
        <Menu />
        
        <div style={{ padding: '20px 20px 0 20px' }}>
          <FreePlanInfoCard />
          <FreePlanBanner />
        </div>
        
        <Banner />
      </section>
    </FreeExpiredGuard>
  );
}

export default Main;
